import { prefectures } from "./prefectures";

export interface JapaneseAddressParts {
	prefecture?: string | null;
	city?: string | null;
	street?: string | null;
	fallback?: string | null;
}

const clean = (value?: string | null): string => (value ?? "").trim();

const ensurePrefectureFirst = (address: string): string => {
	const trimmed = address.trim();
	if (!trimmed) return "";
	const matchedPrefecture = prefectures.find((pref) => trimmed.includes(pref));
	if (!matchedPrefecture) return trimmed;
	if (trimmed.startsWith(matchedPrefecture)) return trimmed;
	const rest = trimmed
		.replace(matchedPrefecture, "")
		.replace(/^[\s,、,.-]+/, "")
		.trim();
	return rest ? `${matchedPrefecture} ${rest}` : matchedPrefecture;
};

/**
 * Join prefecture → city → street in natural Japanese order.
 * If individual parts are not available, fallback to a best-effort normalized string.
 */
export const formatJapaneseAddress = (
	parts: JapaneseAddressParts
): string => {
	const prefecture = clean(parts.prefecture);
	const city = clean(parts.city);
	const street = clean(parts.street);
	const useStreetDirectly = Boolean(prefecture || city);
	const segments = [prefecture, city];
	if (useStreetDirectly && street) {
		segments.push(street);
	}

	const filtered = segments.filter(Boolean);
	if (filtered.length > 0) {
		return filtered.join(" ");
	}

	const fallback = clean(parts.fallback);
	if (!fallback) return "";

	return ensurePrefectureFirst(fallback);
};
